<template>
  <div
    class="table-head"
    ref="tableHead"
    :style="TableHeadWidth"
  >
    <div
      class="table"
      ref="thead"
    >
      <div class="thead">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tbl-head',

  inject: {
    tblConfig: {}
  },

  data () {
    return {
      tblHead_w: null
    }
  },
  computed: {
    getDataLoading () {
      return this.$parent.$parent.dataLoading
    },

    TableHeadWidth () {
      let width = this.tblConfig.body_w

      return { width: width + 'px' }
    }
  },

  mounted () {
    this.$nextTick(() => {
      if (!this.tblConfig.body_w) {
        this.$refs.tableHead.removeAttribute('style')
      }
    })
  }
}
</script>
